var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppBarCreateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9345 15.9024C21.9345 15.8677 21.8998 15.7984 21.8998 15.7638C21.8652 15.6945 21.8652 15.6598 21.8305 15.6252L12.9959 0.450394C12.9612 0.381102 12.8919 0.277165 12.8226 0.24252C12.6494 0.0692914 12.4415 0 12.2337 0C12.0604 0 11.9219 0.0692914 11.7833 0.138583C11.6793 0.207874 11.6101 0.277165 11.5754 0.381102L0.211625 15.5213C0.142334 15.5906 0.0730422 15.6945 0.0383965 15.8331C0.00375086 15.9024 0.00375081 15.9717 0.00375081 16.0409C-0.0308949 16.3874 0.176979 16.6992 0.523436 16.8378L13.2384 21.9307C13.3423 21.9654 13.4463 22 13.5502 22C13.6888 22 13.862 21.9654 14.0006 21.8614L21.6226 16.7685C21.8998 16.5606 22.0037 16.2488 21.9345 15.9024ZM12.4415 16.8724L12.6148 19.9213L4.99273 16.8724H12.4415ZM12.3376 15.2441H2.42895L11.5754 3.04882L12.3376 15.2441ZM19.7518 15.2441H13.966L13.273 4.15748L19.7518 15.2441ZM18.4699 16.8724L14.2431 19.7134L14.0699 16.8724H18.4699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBarCreateWhite);
export default __webpack_public_path__ + "static/media/appBarCreateWhite.57391b86dcff6a451c272546ec182d4f.svg";
export { ForwardRef as ReactComponent };